// extracted by mini-css-extract-plugin
export default {"indicator":"indicator--KaLifLf2++"};